var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    id: "linkicon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.001,16.243l-3.183,3.182c-0.944,0.944-2.592,0.944-3.536,0l-0.707-0.706c-0.472-0.472-0.732-1.1-0.732-1.768 c0-0.668,0.26-1.295,0.732-1.767l4.597-4.597c0.975-0.975,2.562-0.975,3.536,0l0.707,0.708c0.195,0.195,0.512,0.195,0.707,0 c0.195-0.195,0.195-0.512,0-0.707l-0.707-0.708c-1.364-1.365-3.586-1.365-4.95,0l-4.597,4.597 c-0.661,0.66-1.025,1.539-1.025,2.474c0,0.935,0.364,1.814,1.025,2.475l0.707,0.706c0.661,0.661,1.54,1.025,2.476,1.025 c0.935,0,1.814-0.364,2.475-1.025l3.183-3.182c0.195-0.195,0.195-0.512,0-0.707C12.513,16.047,12.196,16.047,12.001,16.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.132,4.575l-0.707-0.707c-1.364-1.364-3.585-1.364-4.949,0l-3.182,3.181c-0.195,0.195-0.195,0.512,0,0.707 c0.195,0.195,0.512,0.195,0.707,0l3.182-3.181c0.975-0.975,2.561-0.974,3.535,0l0.707,0.707c0.472,0.472,0.732,1.1,0.732,1.768 c0,0.668-0.26,1.296-0.732,1.768l-4.596,4.596c-0.473,0.473-1.1,0.733-1.768,0.733h0c-0.667,0-1.294-0.26-1.766-0.732 c-0.195-0.196-0.513-0.195-0.707-0.001c-0.196,0.195-0.196,0.512-0.001,0.707c0.661,0.662,1.539,1.026,2.474,1.026h0 c0.935,0,1.814-0.364,2.475-1.026l4.596-4.596c0.661-0.661,1.025-1.54,1.025-2.475C21.157,6.115,20.793,5.236,20.132,4.575z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "New_icons_1_"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.079e5a33b7020799157c6e0f56473082.svg";
export { ForwardRef as ReactComponent };